import React from "react";
import { Row, Col, Input, Typography } from "antd";
import { treatmentStepErrors, ALIGNER_MIN, ALIGNER_MAX } from "./treatmentSteps";

const { Text } = Typography;

const inputHeight = { height: '40px' };

/**
 * "From … To … aligner" on one treatment step.
 *
 * The create and update screens both ask for this and both used to
 * inline the same pair of unvalidated number boxes, so a plan could be
 * saved with an empty, negative, fractional or absurdly large range —
 * see treatmentSteps.js for what is actually allowed.
 *
 * Controlled rather than uncontrolled: the boxes were rendered with
 * `defaultValue`, so nothing could correct or clear them once typed in,
 * and a step whose numbers came back from the server could not be shown
 * as wrong.
 */
const TreatmentStepRange = ({ value, onChange, disabled }) => {
  const step = value || {};
  const errors = treatmentStepErrors(step);
  const message = errors.from || errors.to;

  const field = (name) => ({
    style: inputHeight,
    type: 'number',
    min: ALIGNER_MIN,
    max: ALIGNER_MAX,
    step: 1,
    disabled,
    status: errors[name] ? 'error' : undefined,
    'aria-invalid': errors[name] ? true : undefined,
    placeholder: `${ALIGNER_MIN}–${ALIGNER_MAX}`,
    value: step[name] === null || step[name] === undefined ? '' : step[name],
    onChange: (e) => onChange(name, e.target.value),
  });

  return (
    <>
      <Row align="middle" gutter={ 12 } style={ { marginTop: 14 } }>
        <Col flex="none"><Text strong>From</Text></Col>
        <Col flex="auto"><Input { ...field('from') } /></Col>
        <Col flex="none"><Text strong>To</Text></Col>
        <Col flex="auto"><Input { ...field('to') } /></Col>
        <Col flex="none"><Text strong>aligner</Text></Col>
      </Row>
      { message && <p className="tp-range-error" role="alert">{ message }</p> }
    </>
  );
};

export default TreatmentStepRange;
